import Manager, { IManager } from "../services/Manager";

export default class ApiManager {
  protected apiManager: IManager = Manager;
}
